import { Injectable } from '@angular/core';

import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import {
    ReconciliationGridObject, ReconciliationObject,
} from '@libs/types/src/mado/object-type';
import { filterFrag } from './types/filter.types';
import { ReconciliationCreateInput, ReconciliationUpdateInput } from '@libs/types/src/mado/input-type';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';

@Injectable({ providedIn: 'root' })
export class ReconciliationGqlService extends GqlServiceV2 {

    public getReconciliations(input: GridInput | null, frag: string) {
        return this.query<ReconciliationGridObject>(
            `
                query($input: GridInput!) {
                    reconciliation {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createReconciliation(input: ReconciliationCreateInput, frag: string) {
        return this.mutate<ReconciliationObject>(
            `
                mutation($input: ReconciliationCreateInput!) {
                    reconciliation {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateReconciliation(input: ReconciliationUpdateInput, frag: string) {
        return this.mutate<ReconciliationObject>(
            `
                mutation($input: ReconciliationUpdateInput!) {
                    reconciliation {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteReconciliation(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    reconciliation {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
